'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Button = require('@narvar/nth-block-button');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Select = require('@narvar/nth-block-select');
var ActionButtonsContainer = require('../../../../common/components/layout/ActionButtonsContainer.js');
var PageWrapper = require('../../../../common/components/layout/PageWrapper.js');
var DesktopWorkflowContent = require('../../../../common/components/layout/DesktopWorkflowContent.js');
var ItemCardClaims = require('../../../../common/components/ItemCardClaims.js');
var SecondaryButton = require('../../../../common/components/SecondaryButton.js');
var ItemQuantityProvider = require('../../../../common/views/ItemQuantity/ItemQuantityProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select);

const QuantitySelectionDesktop = () => {
  const {
    claimsButtonBack,
    claimsButtonNext,
    claimsQuantityInputLabel,
    claimsQuantityTitle
  } = nthHookTranslations.useTranslations();
  const {
    currentItemDetails: itemDetails,
    currentItemClaim: claimDetails,
    quantity,
    onQuantityChange,
    onSubmit,
    onBack,
    options
  } = ItemQuantityProvider.useItemQuantity();
  return /*#__PURE__*/React__default["default"].createElement(PageWrapper["default"], null, /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContent, null, /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentLeft, null, /*#__PURE__*/React__default["default"].createElement(ItemCardClaims["default"], {
    itemDetails: itemDetails,
    claimDetails: claimDetails,
    layout: "vertical"
  })), /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentRight, null, /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentHeader, {
    title: claimsQuantityTitle
  }), /*#__PURE__*/React__default["default"].createElement(Select__default["default"], {
    label: claimsQuantityInputLabel || '',
    options: options,
    name: "quantity",
    value: quantity,
    onChange: onQuantityChange
  }), /*#__PURE__*/React__default["default"].createElement(ActionButtonsContainer["default"], null, /*#__PURE__*/React__default["default"].createElement(SecondaryButton["default"], {
    big: true,
    onClick: onBack
  }, claimsButtonBack), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    disabled: Boolean(!quantity),
    onClick: onSubmit
  }, claimsButtonNext)))));
};
var ItemQuantityDesktop = nthHookTranslations.withTranslationsProvider(QuantitySelectionDesktop, {
  translationKeys: ['claimsButtonBack', 'claimsButtonNext', 'claimsQuantityInputLabel', 'claimsQuantityTitle']
});

exports["default"] = ItemQuantityDesktop;
